/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMenuGet$Any } from '../fn/menu/api-menu-get-any';
import { ApiMenuGet$Any$Params } from '../fn/menu/api-menu-get-any';
import { apiMenuGet$Json } from '../fn/menu/api-menu-get-json';
import { ApiMenuGet$Json$Params } from '../fn/menu/api-menu-get-json';
import { apiMenuGet$JsonOdataMetadataFull } from '../fn/menu/api-menu-get-json-odata-metadata-full';
import { ApiMenuGet$JsonOdataMetadataFull$Params } from '../fn/menu/api-menu-get-json-odata-metadata-full';
import { apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/menu/api-menu-get-json-odata-metadata-full-odata-streaming-false';
import { ApiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/menu/api-menu-get-json-odata-metadata-full-odata-streaming-false';
import { apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/menu/api-menu-get-json-odata-metadata-full-odata-streaming-true';
import { ApiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/menu/api-menu-get-json-odata-metadata-full-odata-streaming-true';
import { apiMenuGet$JsonOdataMetadataMinimal } from '../fn/menu/api-menu-get-json-odata-metadata-minimal';
import { ApiMenuGet$JsonOdataMetadataMinimal$Params } from '../fn/menu/api-menu-get-json-odata-metadata-minimal';
import { apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/menu/api-menu-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/menu/api-menu-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/menu/api-menu-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/menu/api-menu-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiMenuGet$JsonOdataMetadataNone } from '../fn/menu/api-menu-get-json-odata-metadata-none';
import { ApiMenuGet$JsonOdataMetadataNone$Params } from '../fn/menu/api-menu-get-json-odata-metadata-none';
import { apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/menu/api-menu-get-json-odata-metadata-none-odata-streaming-false';
import { ApiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/menu/api-menu-get-json-odata-metadata-none-odata-streaming-false';
import { apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/menu/api-menu-get-json-odata-metadata-none-odata-streaming-true';
import { ApiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/menu/api-menu-get-json-odata-metadata-none-odata-streaming-true';
import { apiMenuGet$JsonOdataStreamingFalse } from '../fn/menu/api-menu-get-json-odata-streaming-false';
import { ApiMenuGet$JsonOdataStreamingFalse$Params } from '../fn/menu/api-menu-get-json-odata-streaming-false';
import { apiMenuGet$JsonOdataStreamingTrue } from '../fn/menu/api-menu-get-json-odata-streaming-true';
import { ApiMenuGet$JsonOdataStreamingTrue$Params } from '../fn/menu/api-menu-get-json-odata-streaming-true';
import { apiMenuGet$Plain } from '../fn/menu/api-menu-get-plain';
import { ApiMenuGet$Plain$Params } from '../fn/menu/api-menu-get-plain';
import { apiMenuGet$Xml } from '../fn/menu/api-menu-get-xml';
import { ApiMenuGet$Xml$Params } from '../fn/menu/api-menu-get-xml';
import { UserModelResult } from '../models/user-model-result';

@Injectable({ providedIn: 'root' })
export class MenuService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMenuGet()` */
  static readonly ApiMenuGetPath = '/api/menu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimal$Response(params?: ApiMenuGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataMinimal(params?: ApiMenuGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFull$Response(params?: ApiMenuGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataFull(params?: ApiMenuGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNone$Response(params?: ApiMenuGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataMetadataNone(params?: ApiMenuGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataStreamingTrue$Response(params?: ApiMenuGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataStreamingTrue(params?: ApiMenuGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataStreamingFalse$Response(params?: ApiMenuGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$JsonOdataStreamingFalse(params?: ApiMenuGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Json$Response(params?: ApiMenuGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Json(params?: ApiMenuGet$Json$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Xml$Response(params?: ApiMenuGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Xml(params?: ApiMenuGet$Xml$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Plain$Response(params?: ApiMenuGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Plain(params?: ApiMenuGet$Plain$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMenuGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Any$Response(params?: ApiMenuGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
    return apiMenuGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMenuGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMenuGet$Any(params?: ApiMenuGet$Any$Params, context?: HttpContext): Observable<UserModelResult> {
    return this.apiMenuGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelResult>): UserModelResult => r.body)
    );
  }

}
